module.exports = __webpack_public_path__ + "static/media/oryza_sativa.whole_plant.feb47a20.svg";